const TitlePrimary = ({children}) => {
  return (
    <h1>{children}</h1>
  )
}

export { TitlePrimary }